import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { cookiePolicy } from './legalContent';

const CookiePolicy = () => {
  return <LegalPageLayout document={cookiePolicy} />;
};

export default CookiePolicy;
